function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M7.628 24.786h16.224V8.78H7.628v16.006zm17.44-17.22V26H6.413V7.566h18.653zm1.31-1.227V10.6h1.215V5.125H3.888v5.477h1.214V6.34h21.276zm-9.848 7.29a1.057 1.057 0 0 0 1.02-1.614c-.218-.345-.615-.533-1.093-.48H15v2.092l1.53.002zM15 18.313h-1.215v-7.99h.607l1.992.004a2.27 2.27 0 0 1 2.193 3.468c-.47.74-1.323 1.146-2.12 1.045H15v3.474zm-2.26-3.473v-1.214l2.26.003v1.21h-2.26zm-.01 1.786V15.41h5.354v1.214H12.73zM10.323 8.78v10.336a3.728 3.728 0 0 1 3.07 3.07h4.693a3.743 3.743 0 0 1 3.082-3.07V8.78H10.323zm12.06 11.5h-.608a2.526 2.526 0 0 0-2.526 2.516l-.002.605H12.23v-.606a2.514 2.514 0 0 0-2.514-2.514H9.11V7.566h13.273V20.28zM7.02 15.18v1.214H4.13a4.14 4.14 0 0 1-4.127-4.25V4.127A4.14 4.14 0 0 1 4.13 0h23.222a4.14 4.14 0 0 1 4.127 4.13v8.016a4.142 4.142 0 0 1-4.13 4.127h-2.89v-1.215h2.888a2.926 2.926 0 0 0 2.916-2.914V4.13a2.926 2.926 0 0 0-2.914-2.917H4.133A2.926 2.926 0 0 0 1.216 4.13v8.034A2.927 2.927 0 0 0 4.13 15.18h2.89z"
});

var SvgPay = function SvgPay(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Pay.7bbba8ee.svg";
export { ForwardRef as ReactComponent };